import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import {
  LoyaltyProfile,
  CustomerProfile,
  Promotion,
} from '@/models';

@Component({
  name: 'CmgOffline',
})
export default class CmgOffline extends Vue {

  get sadAvocado() {
    return this.$appStore.state.cms.images.feedback.sadAvocado.default;
  }

  get isLoggedIn(): boolean {
    return this.$services.customer.isLoggedIn() === true;
  }

  get customer(): CustomerProfile | null {
    return this.$appStore.state.customer.profile;
  }

  get promotions(): Promotion[] {
    return this.$appStore.state.customer.wallet.promotions;
  }

  get loyaltyProfile(): LoyaltyProfile | null {
    if (!this.customer) {
      return null;
    }

    return this.$services.loyalty.getLoyaltyProfile(this.customer);
  }

  get countryCode(): string {
    return this.$appStore.state.ui.countryProfile.countryCode;
  }

  get hasPromotions(): boolean {
    return this.$appStore.state.customer.wallet.promotions.length > 0;
  }

  async mounted() {
    // Check if online ordering flag was turned off in APIM
    await this.$services.featureFlags.validateOnlineOrdering();
  }
}
